import React from "react";

export default function PrivacyPolicy() {
    const updatedAt = "11 de mayo de 2026";

    const sectionStyle = {
        marginBottom: "2rem",
    };

    return (
        <div
            style={{
                maxWidth: "900px",
                margin: "0 auto",
                padding: "40px 20px",
                fontFamily: "Arial, sans-serif",
                lineHeight: 1.6,
                color: "#111",
            }}
        >
            <h1 style={{ fontSize: "2.2rem", marginBottom: "10px" }}>
                Política de Privacidad
            </h1>

            <p style={{ color: "#555", marginBottom: "30px" }}>
                Última actualización: {updatedAt}
            </p>

            <section style={sectionStyle}>
                <p>
                    En <strong>Alecom</strong>, valoramos la privacidad de nuestros
                    usuarios. Esta Política de Privacidad explica cómo recopilamos,
                    utilizamos y protegemos la información cuando utilizas nuestro sitio
                    web y aplicación móvil.
                </p>
            </section>

            <section style={sectionStyle}>
                <h2>1. Información que recopilamos</h2>
                <ul>
                    <li>Nombre, correo electrónico y datos enviados por formularios.</li>
                    <li>Información técnica del dispositivo y navegador.</li>
                    <li>Datos de uso dentro de la aplicación o sitio web.</li>
                    <li>Información necesaria para autenticación e inicio de sesión.</li>
                </ul>
            </section>

            <section style={sectionStyle}>
                <h2>2. Cómo utilizamos la información</h2>
                <ul>
                    <li>Brindar acceso a nuestros servicios.</li>
                    <li>Mejorar rendimiento y experiencia del usuario.</li>
                    <li>Atender soporte o solicitudes.</li>
                    <li>Enviar avisos importantes relacionados con la cuenta.</li>
                    <li>Cumplir obligaciones legales.</li>
                </ul>
            </section>

            <section style={sectionStyle}>
                <h2>3. Compartición de datos</h2>
                <p>
                    No vendemos información personal. Podemos compartir datos únicamente
                    con proveedores tecnológicos necesarios para operar nuestros servicios
                    (hosting, autenticación, analítica, almacenamiento) o cuando la ley lo
                    requiera.
                </p>
            </section>

            <section style={sectionStyle}>
                <h2>4. Seguridad</h2>
                <p>
                    Implementamos medidas razonables de seguridad para proteger la
                    información contra acceso no autorizado, pérdida o alteración.
                </p>
            </section>

            <section style={sectionStyle}>
                <h2>5. Cookies y tecnologías similares</h2>
                <p>
                    Nuestro sitio web puede utilizar cookies o herramientas similares para
                    mejorar navegación, recordar preferencias y analizar tráfico.
                </p>
            </section>

            <section style={sectionStyle}>
                <h2>6. Derechos del usuario</h2>
                <p>
                    Puedes solicitar acceso, corrección o eliminación de tus datos,
                    sujeto a requisitos legales aplicables.
                </p>
            </section>

            <section style={sectionStyle}>
                <h2>7. Menores de edad</h2>
                <p>
                    Nuestros servicios no están dirigidos intencionalmente a menores de
                    edad sin autorización de padres o tutores.
                </p>
            </section>

            <section style={sectionStyle}>
                <h2>8. Cambios a esta política</h2>
                <p>
                    Podemos actualizar esta Política de Privacidad en cualquier momento.
                    Los cambios serán publicados en esta misma página.
                </p>
            </section>

            <section style={sectionStyle}>
                <h2>9. Contacto</h2>
                <p>
                    Si tienes dudas sobre esta Política de Privacidad, puedes contactarnos
                    a través de los canales oficiales de Alecom.
                </p>
            </section>
        </div>
    );
}